import { styled, Drawer } from "@mui/material";

export const NavbarContainer = styled("div")(({ theme,dark }) => ({
  width: "100vw",
  height: 60,
  // backgroundColor:'#fff',
  // backgroundColor:'#3957D2',
  // borderBottom:'5px solid white',
  // position: 'fixed',
  // top:'0px',
  zIndex: 99999,
  maxWidth: "1400px",
  margin: "0 auto",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  "& .link-container": {
    margin: "15px 10px 15px 10px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  "& .logo-svg": {
    transform: "scale(0.8)",
    marginTop: 20,
    '& path':{
        stroke:dark?'#1C2028':'#fff',
    }
  },
  "& .switch-section": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& .menu-svg": {
      marginLeft: "20px",
      cursor: "pointer",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
  },

  // opacity: 0.1
  // borderRadius:'0px 0px 10px 10px'
}));

export const NavbarLink = styled("a")(({ theme, dark }) => ({
  width: "fit-content",
  height: "fit-content",
  backgroundColor: "transparent",
  textDecoration: "none",
  color: dark ? "#1C2028" : "#fff",
  margin: "10px 10px 0 10px",
  padding: "8px 20px",
  textAlign: "center",
  borderRadius: "5px",
  fontWeight: 600,
  transition: "all 0.2s ease-in",
  "&:hover": {
    color: dark ? "#FF3B81" : "#3957D2",
    backgroundColor: dark ? "#1C2028" : "#fff",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "0.8em",
    margin: "10px 5px 0 5px",
    padding: "8px 10px",
  },
}));

export const MenuDrawer = styled(Drawer)(({ theme,dark }) => ({
  "& .MuiPaper-root": {
    width: "40vw",
    height: "96vh",
    marginTop: "2vh",
    marginRight: "2vh",
    borderRadius: "5px",
    backgroundColor:dark?"#FF3B81": "#3957D2",
    zIndex: 9999999,
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "& .logo-svg": {
      marginBottom: 20,
      '& path':{
        stroke:dark?'#1C2028':'#fff',
    }
    },
    [theme.breakpoints.down("sm")]: {
      width: "60vw",
    },
  },
}));

export const MenuBarItem = styled("div")(({dark}) => ({
  width: "100%",
  height: "fit-content",
  padding: "10px 30px",
  color:dark?"#1C2028": "#fff",
  margin: "10px 0",
  borderRadius: 5,
  display: "grid",
  placeItems: "center",
  fontWeight: 600,
  transition: "all 0.2s ease-in",
  cursor: "pointer",

  "&:hover": {
    color: dark ? "#FF3B81" : "#3957D2",
    backgroundColor: dark ? "#1C2028" : "#fff",
  },
}));

export const DarkModeBtn = styled("div")(({ dark }) => ({
  width: 35,
  height: 35,
  borderRadius: "100%",
  backgroundColor: dark ? "#1C2028" : "#fff",
  display: "grid",
  placeItems: "center",
}));
